import React from "react"
import PropTypes from "prop-types"
import Ionicon from "react-ionicons"
import {keys} from "lodash"

import {publicTagNames} from "../../../../data"

import { Title, SubTitle, Footer, Wrapper, TextContainer, TypeContainer, Type } from "./Ticket.styles"

const typesColor = {
  "2sn6dbecc3": "#D02800",
  "80ulgbfn21": "#00963D",
  k0bb01mkds: "#FF8802",
  chzlh8hklq: "#0979AA",
}

const getBorderRadius = (i, array) => {
  if (i == 0 && array.length == 1) return {borderRadius: "5px 0 10px 0"}
  else if (i == 0 && array.length > 1) return {borderRadius: "5px 0 0 0"}
  else if (i == array.length - 1) return {borderRadius: "0 0 10px 0"}
  else return {borderRadius: "0"}
}

const propTypes = {
  elementInfo: PropTypes.shape({
    tags: PropTypes.object,
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node,
    footer: PropTypes.node
  }),
  onClick: PropTypes.func.isRequired,
  // #TODO missing proptypes
}

const Ticket = ({ elementInfo, onClick, wrapperStyle, containerStyle, listLength }) => (
  <div
    className="ticket-wrapper-thing"
    style={{...Wrapper(elementInfo, listLength), ...wrapperStyle}}
    onClick={() => onClick()}
  >
    {
      elementInfo.tags && (
        <div style={TypeContainer}>
          {
            keys(elementInfo.tags)
              .filter(tag => elementInfo.tags[tag] && publicTagNames[tag])
              .map((tag, i, array) => (
                <div key={tag} style={{...Type, ...getBorderRadius(i, array)}}>
                  <div
                    style={{
                      backgroundColor: typesColor[tag] || "#D02800",
                      borderRadius: "50%",
                      margin: "0 5px 0 5px",
                      width: "3vh",
                      height: "3vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Ionicon
                      icon={publicTagNames[tag].icon}
                      fontSize="2.5vh"
                      color="white"
                    />
                  </div>
                  {publicTagNames[tag].name}
                </div>
              ))
          }
        </div>
      )
    }

    <div style={TextContainer(elementInfo)}>
      <div style={{...Title(elementInfo.backgroundColor == "dark"), ...containerStyle}}>
        {elementInfo.title}
      </div>
      <div className="ellipsis" style={SubTitle}>
        {elementInfo.subtitle}
      </div>
      <div style={Footer}>
        {elementInfo.footer}
      </div>
    </div>
  </div>
)

Ticket.props = propTypes

export default Ticket



// WEBPACK FOOTER //
// ./src/app/catalogo/components/Ticket.jsx